'use client';
import { AlertProps } from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { Toast } from './index';

export type ToastData = {
  open: boolean;
  kind?: AlertProps['severity'];
  text: string;
  subtext?: string;
  autoHide?: boolean;
};

/**
 * The app's Toast, connected to its Redux store. Errors hide after 10 seconds, so long messages can be read; other kinds
 * after 5 seconds. A toast that asks not to (`autoHide: false`) stays until closed.
 *
 * @param {Function} selectToast - Reads the toast data from the app's state.
 * @param {Function} hideToast - The app's action creator that closes the toast.
 */
export const ReduxToast = <State,>({
  selectToast,
  hideToast,
}: {
  selectToast: (state: State) => ToastData;
  hideToast: () => { type: string };
}) => {
  const dispatch = useDispatch();
  const { open, kind, text, subtext, autoHide } = useSelector(selectToast);
  return (
    <Toast
      open={open}
      kind={kind}
      text={text}
      subtext={subtext}
      autoHideDuration={autoHide === false ? null : kind === 'error' ? 10000 : 5000}
      close={() => dispatch(hideToast())}
    />
  );
};
